<template>
  <div class="Container">
    <br />
    <h2 class="ViewHeading">Clarence Monitoring System</h2>
    <b-row
      ><b-col>
        <h4>{{ this.selectedlocation }}</h4>
      </b-col></b-row
    >

    <b-modal
      ref="LoadingModal"
      id="LoadingModal"
      content-class="Modal"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      centered
      hide-header
    >
     <div class="container_row" >
        <div class="layer2">
          <h1 class="HeadingText1">Loading Data...</h1>

          <img
            class="Logo"
            alt="Angelguard logo"
            src="../assets/LogoOnly.png"
          />
        </div>
    </div>
</b-modal>

    <b-modal
      ref="cookieModal"
      id="cookieModal"
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      title="Cookie Modal"
      content-class="Modal"
    >
      <div>
        <h3>Cookie Policy Statement</h3>

        <p>
          In Seraph Protect we uses cookies to help us show you the correct
          information and ensure the correct user details are logged. We use
          cookies to enable and support our security features, and to help us to
          detect malicious activity and any violations of our user agreement.
        </p>

        <p>
          Cookies are important to the proper function of this site. We use
          cookies to enable strictly necessary functionality such as
          Authentication & Security and Session Management. Without these
          cookies the Seraph Protect system will be unable to function.
        </p>

        <p>
          Authentication Cookies are used purely to verify a user’s identity and
          ensure that the user is logged in and has authenticated through our
          authorisation services. Authorisation is provided via Auth0 services.
        </p>

        <p>
          Session Cookies are used to manage your inputs and preferences across
          your session within the application. This means that your actions,
          data changes and preferences are remembered from page to page.
        </p>

        <p>
          Security Cookies are used to ensure and track that users are
          authorised and ensure that their access is restricted to only
          specified areas defined by their user access group.
        </p>

        <p>
          These cookies are used solely for the purposes outlined above and are
          not persisted beyond the current session, they are deleted when you
          log out.
        </p>

        <br />

        <div id="cookieButton">
          <button class="button" v-on:click="acceptModal()">
            Ok
          </button>
        </div>
      </div>
    </b-modal>

    <!-- <div v-if="profileportal === 'CEU'">
      <DashInnerCEU />
    </div>
    <div v-if="profileportal === 'WMC' || profileportal === 'Admin'">
      <DashInnerWMC />
    </div>
    <div v-if="profileportal === 'BMU' || profileportal === 'Admin'">
      <DashInnerBMU />
    </div> -->
    <div v-if="profileportal === 'SEN'">
      <DashInnerSEN @DashLoad="ShowHideModal"/>
    </div> 
    <div v-if="profileportal != 'SEN'">
      <DashInnerFull @DashLoad="ShowHideModal" />
    </div>
  </div>
</template>

<script>

import DashInnerSEN from "@/components/DashboardSEN";
import DashInnerFull from "@/components/DashboardClarenceFull";
import axios from "axios";

export default {
  components: {
    DashInnerSEN,
    DashInnerFull,
  },
  computed: {},
  mounted() {

    let UserAccessGroup = this.$ProfilePortal;
    if (UserAccessGroup == null) {
      this.$router.push("/");
    }

    let current = new Date();
    let HistoryDate =
      current.getFullYear() +
      "-" +
      (current.getMonth() + 1) +
      "-" +
      current.getDate();
    let HistoryTime =
      current.getHours() +
      ":" +
      current.getMinutes({ minimumIntegerDigits: 2 }) +
      ":" +
      current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });

    let EventHistory = "Logged In";

    axios.get("https://www.cloudflare.com/cdn-cgi/trace").then((response) => {
      this.response = response.data;
      let UserIPAddress = this.response.substring(
        this.response.search("ip=") + 3,
        this.response.search("ts=") - 1
      );
      let sendUrl =
        "https://bg4rfm4uqd.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/userhistory";
      let sendData = {
        UserURN: this.UserURN,
        UserIPAddress: UserIPAddress,
        HistoryDate: HistoryDate,
        HistoryTime: HistoryTime,
        HistoryNote: EventHistory,
        ProfilePortal: this.$ProfilePortal,
      };
      let sendHeaders = this.$apikeyPost;
      axios
        .post(sendUrl, sendData, sendHeaders)
        .then((response) => {
          response;
        })
        .catch((err) => "error: " + err);
    });
    this.$bvModal.show("LoadingModal");
  },

  created() {
    this.$auth.renewTokens().catch((err) => {
      err.message;
    });
    this.$root.$refs.A = this;
  },

  data() {
    return {
      loaded: false,
      profileportal: null,
      Auth0loggedIn: false,
      profile: {},
      themepref: this.$ThemePref,
      accessGroup: null,
      name: "",
      cookieAccept: "TRUE",
      userType: null,
      FullUserName: null,
      UserURN: this.$UserURN,
      selectedlocation: localStorage.getItem("CurrentLocation"),
    };
  },
  methods: {
    ShowHideModal(Status) {
      if (Status == "Loaded") {
        this.$bvModal.hide("LoadingModal");
      } else if (Status == "Loading") {
        this.$bvModal.show("LoadingModal");
      }
    },

    handleLoginEvent(data) {
      this.profile = data.profile;
      this.Auth0loggedIn = data.Auth0loggedIn;
      this.profileportal = data.profileportal;
      this.themepref = data.themepref;
      this.accessGroup = data.accessGroup;
      this.name = data.profile.name;
    },

    showModal() {
      this.$bvModal.show("cookieModal");
    },

    acceptModal() {
      this.cookieAccept = "TRUE";
      localStorage.cookieAccept = this.cookieAccept;
      this.LookUpRequest = {
        RequestType: "UpdateConsent",
        UserType: this.profileportal,
        UserDict: [{ UserURN: this.UserURN, ConsentGiven: "TRUE" }],
      };

      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/useradmin";
      let LookUpHeaders = this.$apikeyPost;
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
        });

      this.$refs["cookieModal"].hide();
    },

    closeModal() {
      this.$refs["cookieModal"].hide();
    },
  },
};
</script>
<style>
#cookieButton {
  text-align: center;
}

#cookieModal.p {
  width: 100%;
  font-size: 10rem;
}

.container {
  border: none;
}

h2 {
  padding-top: 15px;
}
.ModalContainer {
  height: 33vh;
  align-content: center;
  align-items: center;
}


@keyframes BackgroundGlow {
  0% {
    box-shadow: 0 0 15px 8px rgb(109, 136, 195),
      /* inner white */ 0 0 25px 15px rgb(225, 225, 225),
      /* middle magenta */ 0 0 35px 22px rgb(78, 205, 196); /* outer cyan */
  }
  20% {
    box-shadow: 0 0 30px 15px rgb(109, 136, 195),
      /* inner white */ 0 0 50px 30px rgb(225, 225, 225),
      /* middle magenta */ 0 0 70px 45px rgb(78, 205, 196); /* outer cyan */
  }
  40% {
    box-shadow: 0 0 60px 30px rgb(109, 136, 195),
      /* inner white */ 0 0 100px 60px rgb(225, 225, 225),
      /* middle magenta */ 0 0 140px 90px rgb(78, 205, 196); /* outer cyan */
  }
  60% {
    box-shadow: 0 0 60px 30px rgb(109, 136, 195),
      /* inner white */ 0 0 100px 60px rgb(225, 225, 225),
      /* middle magenta */ 0 0 140px 90px rgb(78, 205, 196); /* outer cyan */
  }
  80% {
    box-shadow: 0 0 30px 15px rgb(109, 136, 195),
      /* inner white */ 0 0 50px 30px rgb(225, 225, 225),
      /* middle magenta */ 0 0 70px 45px rgb(78, 205, 196); /* outer cyan */
  }
  100% {
    box-shadow: 0 0 15px 8px rgb(109, 136, 195),
      /* inner white */ 0 0 25px 15px rgb(225, 225, 225),
      /* middle magenta */ 0 0 35px 22px rgb(78, 205, 196); /* outer cyan */
  }
}

.Logo {
  scale: 150%;
  margin-top: 5rem;
  width: 15%;
  min-width: 150px;
}

.container_row {
  display: grid;
  /* height: 100vh; */
  height: 60vh !important;
}

.layer1,
.layer2 {
  grid-column: 1;
  grid-row: 1;
  background-color: rgb(109, 136, 195);
  opacity: 0.5;
}

.layer1 span {
  display: grid;
  place-items: center;
}

.HeadingText1 {
  color: white;
}
</style>
